import AxiosInstance from './config/Http'
import Config from './config/Constants'

export default {
    patch: (id: string, body: any) => {
        delete body.company
        body.id = id
        return AxiosInstance.patch<any>(`${Config.core.tickets}/${id}`, body)
    },
}
